import { useParams } from 'react-router';
export function getStreamPathname(streamPartId) {
    return `/stream/${streamPartId}`;
}
export function getStreamUrl(streamPartId) {
    const url = new URL(window.location.toString());
    url.hash = getStreamPathname(streamPartId);
    return url.toString();
}
export function useRequiredParam(key) {
    const value = useParams()[key];
    if (!value) {
        throw new Error(`Invalid context (missing "${key}" param`);
    }
    return value;
}
export function generateStreamPartId() {
    return `stream-${Math.random().toString(36).substring(2)}`;
}
